import { PaginatedResponse, PaginatedResponseFromApi } from '@/types';
import {
  MillwrightTask,
  MillwrightTaskApiResponse,
} from '@/apis/tasks/types/tasksApi';

export const millwrightTaskFromApiAdapter = (
  millwrightTask: MillwrightTaskApiResponse,
): MillwrightTask => {
  return {
    outageID: millwrightTask.OutageID,
    empID: millwrightTask.EmpID,
    taskID: millwrightTask.TaskID,
    taskDescription: millwrightTask.TaskDescription,
    dateWorked: millwrightTask.date_worked,
  };
};

export const outageMillwrightTasksFromApiAdapter = (
  response: PaginatedResponseFromApi<MillwrightTaskApiResponse>,
): PaginatedResponse<MillwrightTask> => {
  return {
    results: response?.results.map(millwrightTaskFromApiAdapter) ?? [],
    total: response.total,
    limit: response.limit,
    offset: response.offset,
    nextOffset: response.next_offset,
    prevOffset: response.prev_offset,
  };
};
